import { render, staticRenderFns } from "./BreadcrumbItemEdit.vue?vue&type=template&id=3594d82c&"
import script from "./BreadcrumbItemEdit.vue?vue&type=script&lang=js&"
export * from "./BreadcrumbItemEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports